import type { RouteLocationNormalized } from 'vue-router';
import { route } from 'ziggy-js';

import { useSubscriptionStore } from '@/common/stores/subscription';
import { axios } from '@/helpers/axios';
import { useListingAuditQuotaModalStore } from '@/modules/listing-audit/stores/quotaModal';

const routes = [
  {
    path: '/listing-audit/:id',
    name: 'listing-audit',
    component: () => import('@/modules/listing-audit/pages/Entry.vue'),
    meta: {
      title: 'eRank — Listing Audit',
      metaTags: [
        {
          name: 'description',
          content: 'Get a detailed analysis of your Etsy listing and see how it compares to the competition.',
        },
        {
          page_slug: 'listing-audit',
        },
      ],
      requiresAuth: true,
    },
    beforeEnter: async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
      const listingId = to.params.id;

      if (!listingId || Array.isArray(listingId)) {
        return { name: 'listing-not-found' };
      }

      // Gate on the Listing Audit quota BEFORE the page loads, so a member without
      // remaining quota never lands on a blank audit screen behind the upgrade modal.
      const subscriptionStore = useSubscriptionStore();
      const listingAuditQuota = subscriptionStore.quotas?.listing_audit;

      if (listingAuditQuota && !listingAuditQuota.can_search) {
        useListingAuditQuotaModalStore().open();
        return from.matched.length > 0 ? false : { name: 'dashboard' };
      }

      try {
        const response = await axios.get<{ success: boolean }>(
          route('api.listing-audit.check-status', { id: listingId }),
        );

        if (!response.data.success) {
          return { name: 'listing-not-found' };
        }

        return true;
      } catch {
        return { name: 'listing-not-found' };
      }
    },
  },
  {
    path: '/listing-not-found',
    name: 'listing-not-found',
    component: () => import('@/modules/listing-audit/pages/ListingNotFound.vue'),
    meta: {
      title: 'eRank — Listing Not Found',
      requiresAuth: true,
    },
  },
];

export default routes;
